﻿import { useLayoutEffect } from 'react';

export default () => {
  useLayoutEffect(() => {
    //const originalStyle = window.getComputedStyle(document.body).overflow;
    //document.body.style.overflow = 'hidden';
    document.querySelector('html').classList.add('lockscroll');

    //document.body.style.overflow = originalStyle;
    return () => document.querySelector('html').classList.remove('lockscroll');
  }, []);
}